import * as hmiclientbase from 'components/hmilib/hmiclientbase';
import React from 'react';
import { colorText, MainText } from 'styles';
import { styleCell, styleInput, styleRow, styleTable } from '../../styles';
import { Button } from '@ixyberfree/ixybercomponents';

interface IPropsExeFunc {
    id: string;
    returnTypes: any;
    closeCB?: Function;
    exeCB?: Function;
}

export const ExeFunc: React.FC<IPropsExeFunc> = ({ id, returnTypes, closeCB, exeCB }) => {
    let [result, setResult] = React.useState('');
    let [stateExe, setStateExe] = React.useState('');
    let [param, setParam] = React.useState<string[]>([]);

    const methodInvoke = () => {
        setStateExe('Выполняется...');

        hmiclientbase.SettingsMethodInvoke(id, returnTypes.Name, param).then((data: any) => {
            if (data.error === 200) {
                if (data.result !== null && data.result !== undefined) {
                    setResult(data.result.toString());
                }
                setStateExe('Выполнено');
            } else {
                setStateExe('Ошибка: ' + data.error.toString());
                console.log(data);
            }
        });
    };

    const filteringByType = (inStr: string, type: string) => {
        let outStr: string = '';
        switch (type) {
            case 'System.String': {
                outStr = inStr;
                break;
            }
            case 'System.Single': {
                outStr = inStr.replace(/[^0-9.s\-]/g, '').replace(/(\..*)\./g, '$1');
                break;
            }
            case 'System.Int32': {
                outStr = inStr.replace(/[^0-9\-]/g, '');
                break;
            }
        }
        return outStr;
    };

    const editParam = (key: number, value: string) => {
        if (param[key] !== undefined) {
            param[key] = value;
            setParam([...param]);
        }
    };

    const genTable = () => {
        let arrTr: any[] = [];
        returnTypes.Params.forEach((elem: any, key: number) => {
            console.log(key);
            arrTr.push(
                <tr style={styleRow}>
                    <td style={styleCell}>{elem.Name}</td>
                    <td style={styleCell}>
                        <input
                            key={key}
                            style={styleInput}
                            onChange={(e) => {
                                editParam(key, e.target.value);
                            }}
                            onInput={(e) => {
                                e.currentTarget.value = filteringByType(e.currentTarget.value, elem.ParameterType);
                            }}
                        />
                    </td>
                </tr>
            );
        });
        return arrTr;
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }} /*onClick={() => closeCB && closeCB()}*/
        >
            <div
                style={{
                    padding: '1em',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}>
                <div style={{ overflow: 'auto', marginBottom: '5px' }}>
                    <table style={styleTable}>{genTable()}</table>
                </div>
                <div>
                    <MainText style={{ marginBottom: '5px' }} size={14} color={colorText.main}>
                        Статус: {stateExe}
                    </MainText>
                    <MainText size={14} color={colorText.main}>
                        Ответ: {result}
                    </MainText>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '1em' }}>
                    <Button text="Выполнить" size="small" styleType="filled" onClick={() => methodInvoke()} />
                    <div style={{ width: '1.8em' }}></div>
                    <Button text="Закрыть" size="small" styleType="tinted" onClick={() => closeCB && closeCB()} />
                </div>
            </div>
        </div>
    );
};
